import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {AuthCheck} from '../../helpers'
import {
  SearchDynamicReportContollerClient,
  GetDynamicReportEntityClient,
  SearchAuditClient,
  GetAuditClient,
  ListAuditClient,
  CashFlowReportContollerClient,
} from '../../api'

const SERVICE_URL = window.ENVVARS.REACT_APP_SERVICE_URL

// API Clients
const searchDynamicReportContollerClient = new SearchDynamicReportContollerClient(SERVICE_URL)
const cashFlowReportContollerClient = new CashFlowReportContollerClient(SERVICE_URL)
const getDynamicReportEntityClient = new GetDynamicReportEntityClient(SERVICE_URL)
const searchAuditClient = new SearchAuditClient(SERVICE_URL)
const getAuditClient = new GetAuditClient(SERVICE_URL)
const listAuditClient = new ListAuditClient(SERVICE_URL)

const initialState = {
  loading: false,
  isRedirect: false,
  error: null,
  isDeleted: false,
  isArchived: false,
  saleinvoiceCategory: [],
  saleinvoiceProject: [],
  saleinvoiceDate: [],
  saleinvoiceMonth: [],
  saleinvoiceStatus: [],
  saleinvoiceRealEstateMonth: [],
  expenseinvoiceCategory: [],
  expenseinvoiceProject: [],
  expenseinvoiceDate: [],
  expenseinvoiceMonth: [],
  expenseinvoiceStatus: [],
  projectCompleteRateByProject: [],
  constructionSiteCompleteRateByProject: [],
  blockCompleteRateByConstructionSite: [],
  rootTaskCompleteRateByProject: [],
  dailyTaskCompleteRateByProject: [],
  details: null,
  auditList: [],
  cashflow: {},
  dynamicreport: null,
  audit: null,
}

// Async Thunks
export const searchDynamicReportRequestGetAll = createAsyncThunk(
  'reporting/searchDynamicReportRequestGetAll',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await searchDynamicReportContollerClient.search(
        params.name,
        params.items_per_page,
        params.page,
        params.order,
        params.sort
      )
      dispatch(setDynamicReport(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const cashFlowReportGetAll = createAsyncThunk(
  'reporting/cashFlowReportGetAll',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await cashFlowReportContollerClient.search(params)
      dispatch(setCashflow(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const saleInvoiceChartCategoryGetAll = createAsyncThunk(
  'reporting/saleInvoiceChartCategoryGetAll',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await getDynamicReportEntityClient.saleInvoiceChartCategory(
        params.StartDate,
        params.EndDate,
        params.SaleCategoryId,
        params.PaymentStatusId,
        params.ProjectId
      )
      dispatch(setSaleinvoiceCategory(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const saleInvoiceChartProjectGetAll = createAsyncThunk(
  'reporting/saleInvoiceChartProjectGetAll',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await getDynamicReportEntityClient.saleInvoiceChartProject(
        params.StartDate,
        params.EndDate,
        params.SaleCategoryId,
        params.PaymentStatusId,
        params.ProjectId
      )
      dispatch(setSaleinvoiceProject(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const saleInvoiceChartDateGetAll = createAsyncThunk(
  'reporting/saleInvoiceChartDateGetAll',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await getDynamicReportEntityClient.saleInvoiceChartDate(
        params.StartDate,
        params.EndDate,
        params.SaleCategoryId,
        params.PaymentStatusId,
        params.ProjectId
      )
      dispatch(setSaleinvoiceDate(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const saleInvoiceChartMonthGetAll = createAsyncThunk(
  'reporting/saleInvoiceChartMonthGetAll',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await getDynamicReportEntityClient.saleInvoiceChartMonth(
        params.StartDate,
        params.EndDate,
        params.SaleCategoryId,
        params.PaymentStatusId,
        params.ProjectId
      )
      dispatch(setSaleinvoiceMonth(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const saleInvoiceRealEstateChartMonthGetAll = createAsyncThunk(
  'reporting/saleInvoiceRealEstateChartMonthGetAll',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await getDynamicReportEntityClient.saleInvoiceRealEstateChartMonth(
        params.StartDate,
        params.EndDate,
        params.SaleCategoryId,
        params.PaymentStatusId,
        params.ProjectId
      )
      dispatch(setSaleinvoiceRealEstateMonth(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const saleInvoiceChartStatusGetAll = createAsyncThunk(
  'reporting/saleInvoiceChartStatusGetAll',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await getDynamicReportEntityClient.saleInvoiceChartStatus(
        params.StartDate,
        params.EndDate,
        params.SaleCategoryId,
        params.PaymentStatusId,
        params.ProjectId
      )
      dispatch(setSaleinvoiceStatus(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const expenseInvoiceChartCategoryGetAll = createAsyncThunk(
  'reporting/expenseInvoiceChartCategoryGetAll',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await getDynamicReportEntityClient.expenseInvoiceChartCategory(
        params.StartDate,
        params.EndDate,
        params.StaffId,
        params.ExpenseCategoryId,
        params.PaymentStatusId,
        params.ProjectId
      )
      dispatch(setExpenseinvoiceCategory(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const expenseInvoiceChartProjectGetAll = createAsyncThunk(
  'reporting/expenseInvoiceChartProjectGetAll',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await getDynamicReportEntityClient.expenseInvoiceChartProject(
        params.StartDate,
        params.EndDate,
        params.StaffId,
        params.ExpenseCategoryId,
        params.PaymentStatusId,
        params.ProjectId
      )
      dispatch(setExpenseinvoiceProject(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const expenseInvoiceChartDateGetAll = createAsyncThunk(
  'reporting/expenseInvoiceChartDateGetAll',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await getDynamicReportEntityClient.expenseInvoiceChartDate(
        params.StartDate,
        params.EndDate,
        params.StaffId,
        params.ExpenseCategoryId,
        params.PaymentStatusId,
        params.ProjectId
      )
      dispatch(setExpenseinvoiceDate(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const expenseInvoiceChartMonthGetAll = createAsyncThunk(
  'reporting/expenseInvoiceChartMonthGetAll',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await getDynamicReportEntityClient.expenseInvoiceChartMonth(
        params.StartDate,
        params.EndDate,
        params.StaffId,
        params.ExpenseCategoryId,
        params.PaymentStatusId,
        params.ProjectId
      )
      dispatch(setExpenseinvoiceMonth(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const expenseInvoiceChartStatusGetAll = createAsyncThunk(
  'reporting/expenseInvoiceChartStatusGetAll',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await getDynamicReportEntityClient.expenseInvoiceChartStatus(
        params.StartDate,
        params.EndDate,
        params.StaffId,
        params.ExpenseCategoryId,
        params.PaymentStatusId,
        params.ProjectId
      )
      dispatch(setExpenseinvoiceStatus(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const workPlanProjectCompleteRateByProjectGetAll = createAsyncThunk(
  'reporting/workPlanProjectCompleteRateByProjectGetAll',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await getDynamicReportEntityClient.projectCompleteRateByProject(
        params.ProjectId
      )
      dispatch(setProjectCompleteRateByProject(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const workPlanConstructionSiteCompleteRateByProjectGetAll = createAsyncThunk(
  'reporting/workPlanConstructionSiteCompleteRateByProjectGetAll',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await getDynamicReportEntityClient.constructionSiteCompleteRateByProject(
        params.ProjectId
      )
      dispatch(setConstructionSiteCompleteRateByProject(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const workPlanBlockCompleteRateByConstructionSiteGetAll = createAsyncThunk(
  'reporting/workPlanBlockCompleteRateByConstructionSiteGetAll',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response =
        await getDynamicReportEntityClient.blockCompleteRateWithConstructionSiteByProject(
          params.ProjectId
        )
      dispatch(setBlockCompleteRateByConstructionSite(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const workPlanRootTaskCompleteRateByProjectGetAll = createAsyncThunk(
  'reporting/workPlanRootTaskCompleteRateByProjectGetAll',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await getDynamicReportEntityClient.rootTaskCompleteRateByProject(
        params.ProjectId
      )
      dispatch(setRootTaskCompleteRateByProject(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const workPlanDailyTaskCompleteRateByProjectGetAll = createAsyncThunk(
  'reporting/workPlanDailyTaskCompleteRateByProjectGetAll',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await getDynamicReportEntityClient.dailyTaskCompleteRateByProject(
        params.ProjectId
      )
      dispatch(setDailyTaskCompleteRateByProject(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const auditGetAll = createAsyncThunk('reporting/auditGetAll', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    const response = await searchAuditClient.search(
      params.auditEntityId,
      params.userId,
      params.dateFrom,
      params.dateTo,
      params.type,
      params.items_Per_Page,
      params.page,
      params.order,
      params.sort
    )
    dispatch(setAudit(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const auditGetId = createAsyncThunk('reporting/auditGetId', async (id, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    const response = await getAuditClient.details(id)
    dispatch(setDetails(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const auditGetList = createAsyncThunk('reporting/auditGetList', async (id, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    const response = await listAuditClient.listByGuid(id)
    dispatch(setAuditList(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

// Slice
const reportingSlice = createSlice({
  name: 'reporting',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
      state.loading = false
    },
    setDynamicReport: (state, action) => {
      state.dynamicreport = action.payload
      state.loading = false
    },
    setCashflow: (state, action) => {
      state.cashflow = action.payload
      state.loading = false
    },
    setSaleinvoiceCategory: (state, action) => {
      state.saleinvoiceCategory = action.payload
      state.loading = false
    },
    setSaleinvoiceProject: (state, action) => {
      state.saleinvoiceProject = action.payload
      state.loading = false
    },
    setSaleinvoiceDate: (state, action) => {
      state.saleinvoiceDate = action.payload
      state.loading = false
    },
    setSaleinvoiceMonth: (state, action) => {
      state.saleinvoiceMonth = action.payload
      state.loading = false
    },
    setSaleinvoiceStatus: (state, action) => {
      state.saleinvoiceStatus = action.payload
      state.loading = false
    },
    setSaleinvoiceRealEstateMonth: (state, action) => {
      state.saleinvoiceRealEstateMonth = action.payload
      state.loading = false
    },
    setExpenseinvoiceCategory: (state, action) => {
      state.expenseinvoiceCategory = action.payload
      state.loading = false
    },
    setExpenseinvoiceProject: (state, action) => {
      state.expenseinvoiceProject = action.payload
      state.loading = false
    },
    setExpenseinvoiceDate: (state, action) => {
      state.expenseinvoiceDate = action.payload
      state.loading = false
    },
    setExpenseinvoiceMonth: (state, action) => {
      state.expenseinvoiceMonth = action.payload
      state.loading = false
    },
    setExpenseinvoiceStatus: (state, action) => {
      state.expenseinvoiceStatus = action.payload
      state.loading = false
    },
    setProjectCompleteRateByProject: (state, action) => {
      state.projectCompleteRateByProject = action.payload
      state.loading = false
    },
    setConstructionSiteCompleteRateByProject: (state, action) => {
      state.constructionSiteCompleteRateByProject = action.payload
      state.loading = false
    },
    setBlockCompleteRateByConstructionSite: (state, action) => {
      state.blockCompleteRateByConstructionSite = action.payload
      state.loading = false
    },
    setRootTaskCompleteRateByProject: (state, action) => {
      state.rootTaskCompleteRateByProject = action.payload
      state.loading = false
    },
    setDailyTaskCompleteRateByProject: (state, action) => {
      state.dailyTaskCompleteRateByProject = action.payload
      state.loading = false
    },
    setDetails: (state, action) => {
      state.details = action.payload
      state.loading = false
    },
    setAuditList: (state, action) => {
      state.auditList = action.payload
      state.loading = false
    },
    setAudit: (state, action) => {
      state.audit = action.payload
      state.loading = false
    },
    resetState: (state) => {
      Object.assign(state, initialState)
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => action.type.startsWith('reporting/') && action.type.endsWith('/pending'),
      (state) => {
        state.loading = true
      }
    )
  }
})

// Export actions
export const {
  setLoading,
  setError,
  setDynamicReport,
  setCashflow,
  setSaleinvoiceCategory,
  setSaleinvoiceProject,
  setSaleinvoiceDate,
  setSaleinvoiceMonth,
  setSaleinvoiceStatus,
  setSaleinvoiceRealEstateMonth,
  setExpenseinvoiceCategory,
  setExpenseinvoiceProject,
  setExpenseinvoiceDate,
  setExpenseinvoiceMonth,
  setExpenseinvoiceStatus,
  setProjectCompleteRateByProject,
  setConstructionSiteCompleteRateByProject,
  setBlockCompleteRateByConstructionSite,
  setRootTaskCompleteRateByProject,
  setDailyTaskCompleteRateByProject,
  setDetails,
  setAuditList,
  setAudit,
  resetState,
} = reportingSlice.actions

// Selectors
export const selectReportingLoading = (state) => state.reporting.loading
export const selectReportingError = (state) => state.reporting.error
export const selectReportingDynamicReport = (state) => state.reporting.dynamicreport
export const selectReportingCashflow = (state) => state.reporting.cashflow
export const selectReportingSaleinvoiceCategory = (state) => state.reporting.saleinvoiceCategory
export const selectReportingSaleinvoiceProject = (state) => state.reporting.saleinvoiceProject
export const selectReportingSaleinvoiceDate = (state) => state.reporting.saleinvoiceDate
export const selectReportingSaleinvoiceMonth = (state) => state.reporting.saleinvoiceMonth
export const selectReportingSaleinvoiceStatus = (state) => state.reporting.saleinvoiceStatus
export const selectReportingExpenseinvoiceCategory = (state) =>
  state.reporting.expenseinvoiceCategory
export const selectReportingExpenseinvoiceProject = (state) => state.reporting.expenseinvoiceProject
export const selectReportingExpenseinvoiceDate = (state) => state.reporting.expenseinvoiceDate
export const selectReportingExpenseinvoiceMonth = (state) => state.reporting.expenseinvoiceMonth
export const selectReportingExpenseinvoiceStatus = (state) => state.reporting.expenseinvoiceStatus
export const selectReportingProjectCompleteRateByProject = (state) =>
  state.reporting.projectCompleteRateByProject
export const selectReportingConstructionSiteCompleteRateByProject = (state) =>
  state.reporting.constructionSiteCompleteRateByProject
export const selectReportingBlockCompleteRateByConstructionSite = (state) =>
  state.reporting.blockCompleteRateByConstructionSite
export const selectReportingRootTaskCompleteRateByProject = (state) =>
  state.reporting.rootTaskCompleteRateByProject
export const selectReportingDailyTaskCompleteRateByProject = (state) =>
  state.reporting.dailyTaskCompleteRateByProject
export const selectReportingDetails = (state) => state.reporting.details
export const selectReportingAuditList = (state) => state.reporting.auditList
export const selectReportingAudit = (state) => state.reporting.audit

export default reportingSlice.reducer
